import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import conf from "../config/options";
import { LocalStorageService } from "./services/local-storage.service";
import { NavigationEnd, Router } from "@angular/router";
import { IdleTimeoutService } from "./services/idle-timeout.service";
import {
  formatDashboardTitle,
  resolveDashboardPageTitle,
} from "./shared/helpers/page-title.helper";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  public customLayout: boolean;
  public appConf: any = conf;
  permissions: any;
  showCheckoutRootNotFound = false;
  private readonly checkoutHost = "checkout.paymish.com";
  private readonly shopHost = "shop.paymish.com";
  constructor(
    private localstorage: LocalStorageService,
    public translate: TranslateService,
    private router: Router,
    private idleTimeoutService: IdleTimeoutService,
    private titleService: Title
  ) {
    const language = this.localstorage.getLocalStore("language") || "en";
    localstorage.setLocalStore("language", language);
    translate.setDefaultLang(language);
    translate.use(this.localstorage.getLocalStore("language"));
  }

  ngOnInit(): void {
    this.updateCheckoutHostState();
    this.setPageTitle(this.router.url || window.location.pathname || "/");
    let onFirstClick = async () => {
      if (this.showCheckoutRootNotFound) {
        return;
      }
      // wayfinder map P-T-L/merchant-angular#207 - shop.paymish.com's
      // Public Storefront (/<slug>, root-level, no fixed prefix to add to
      // the whitelist below) never has a token - it's exclusively public,
      // unauthenticated traffic, same as checkoutHost's own carve-out
      // above. Without this, every single click reloaded the page - found
      // live: reported as "anywhere I click, page refreshes".
      if (window.location.hostname === this.shopHost) {
        return;
      }
      if (
        this.router.url === "/auth/login" ||
        this.router.url === "/auth/sign-up"
      ) {
      } else {
        const tokens = this.localstorage.getLocalStorageItem("token");
        try {
          // Don't reload if user is on Paying page
          if (
            !tokens &&
            !this.router.url.startsWith("/pay/") &&
            !this.router.url.startsWith("/checkout/") &&
            !this.router.url.startsWith("/buy/") &&
            !this.router.url.startsWith("/auth/forgot-password") &&
            !this.router.url.startsWith("/auth/reset-password") &&
            !this.router.url.startsWith("/team/join-team") &&
            !this.router.url.startsWith("/digitalproducts") &&
            !this.router.url.startsWith("/dispute/create") &&
            !this.showCheckoutRootNotFound
          ) {
            location.reload();
          }
        } catch (error) {}
      }
    };
    document.addEventListener("click", onFirstClick);
    // auto scroll up when router change
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.updateCheckoutHostState();
        this.setPageTitle(event.urlAfterRedirects || event.url || this.router.url);
        window.scrollTo(0, 0);
      }
    });
  }

  private setPageTitle(url: string): void {
    this.titleService.setTitle(
      formatDashboardTitle(resolveDashboardPageTitle(url))
    );
  }

  private updateCheckoutHostState(): void {
    const currentPath = window.location.pathname || this.router.url || "";
    const isAllowedCheckoutHostPath =
      currentPath.startsWith("/checkout/") ||
      currentPath.startsWith("/transaction-status");
    this.showCheckoutRootNotFound =
      window.location.hostname === this.checkoutHost &&
      !isAllowedCheckoutHostPath;
  }
}
